import { render, staticRenderFns } from "./dishEvaluation.vue?vue&type=template&id=7844d94d&scoped=true&"
import script from "./dishEvaluation.vue?vue&type=script&lang=js&"
export * from "./dishEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./dishEvaluation.vue?vue&type=style&index=0&id=7844d94d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7844d94d",
  null
  
)

export default component.exports